export default {
  "content": "<path fill-rule=\"evenodd\" d=\"M2 12a10 10 0 1120 0 10 10 0 01-20 0zm5 0a1 1 0 001 1h8a1 1 0 001-1 1 1 0 00-1-1H8a1 1 0 00-1 1z\" clip-rule=\"evenodd\"/>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24"
  }
};